import React from 'react'
import { Checkbox, Table } from 'antd'
import { SearchRequest } from '../../../../services/api/interfaces/ApiRequest'
import { BaseListComponentProps, ListComponent } from '../../../BaseComponent'
import { integrationDefinitionsConnect, integrationDefinitionsDisconnect, integrationDefinitionsListSimple, integrationNetworkListSimple } from '../../../../services/integration'


type IntegrationListProps = BaseListComponentProps & {
  integrations: any,
  pagination: any,
  loading: boolean,
  searchOptions: any,
  network_uuid: any,
  loadIntegrations: (args: SearchRequest) => void
}

export default class DefinitionsListOnNetwork extends ListComponent<IntegrationListProps> {

  static defaultProps = {
    loading: false
  }

  state = {
    removed: [] as string[],
    connectedDefinitions: [] as any[]
  }

  tableColumns = [
    {
      title: 'Connected',
      dataIndex: 'main',
      key: 'connected',
      render: (text: string, record: any) => {
        return (
          <Checkbox checked={this.isConnected(record.uuid)} onChange={(e) => this.connectOrDisconnect(record)}/>
        )
      }
    },
    {
      title: 'UUID',
      dataIndex: 'uuid',
      key: 'uuid'
    },
    {
      title: 'Path',
      dataIndex: 'path',
      key: 'path',
      responsive: ['md'] as any
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      responsive: ['md'] as any
    },
    {
      title: 'Condition',
      dataIndex: 'condition',
      key: 'condition',
      responsive: ['md'] as any
    },
    {
      title: 'Value',
      dataIndex: 'value',
      key: 'value',
      responsive: ['md'] as any
    },
    {
      title: 'Priority',
      dataIndex: 'priority',
      key: 'priority',
      responsive: ['md'] as any
    }
    
  ] as any

  protected async load() {

    const shelter = await integrationNetworkListSimple({
      "fields" : [
        "uuid",
        "shelter_id",
        "partner_key"
      ],
      "filters" : {
        "uuid" : this.props.network_uuid
      }
     })

    const temp = await integrationDefinitionsListSimple({
        "fields": [
            "uuid"
        ],
        "filters": {
            "networks.network.uuid" : this.props.network_uuid
        }
    })

     const result = temp.data?.data?.result ? temp.data?.data?.result : null;
     const shelter_result = shelter.data?.data?.result ? shelter.data?.data?.result[0] : null;


     this.setState({connectedDefinitions : result})

    const params = {
      search: {
        deleted: false,
        shelter_id:shelter_result?.shelter_id,
        partner_key:shelter_result?.partner_key,
        global : false
      },
      options: {
      }
    }

    this.props.loadIntegrations(params)

    
  }

  async connectOrDisconnect(definition){
    let arr = this.state.connectedDefinitions ? this.state.connectedDefinitions : [];
  
    if(this.isConnected(definition.uuid)){
      
      const result = await integrationDefinitionsDisconnect({
        "network_uuid" : this.props.network_uuid,
        "definition_uuid" : definition.uuid
      })
      if(result.ok){
        for(let i =0; i < this.state.connectedDefinitions?.length; i++){
          if(this.state.connectedDefinitions[i]?.uuid === definition.uuid){
            arr.splice(i,1);
          }
        }
      }
    }else{
      
      const result = await integrationDefinitionsConnect({
        "network_uuid" : this.props.network_uuid,
        "definition_uuid" : definition.uuid
      })

      if(result.ok){
        (arr as any[]).push({
          uuid:definition.uuid
      })
      }
    }
    this.setState({connectedDefinitions: arr})
  }

  isConnected(integration_uuid){
    for(let i =0; i < this.state.connectedDefinitions?.length; i++){
      if(this.state.connectedDefinitions[i]?.uuid === integration_uuid){
        return true;
      }
    }
    return false;
  }

  render() {
    const { loading, pagination, integrations, loadIntegrations } = this.props
    const { removed } = this.state

    let paginationOptions = {}
    if (pagination) {
      paginationOptions = {
        total: pagination.count,
        pageSize: pagination.limit,
        current: pagination.page
      }
    }

    return (
      <Table
        loading={loading}
        rowKey='uuid'
        columns={this.tableColumns}
        pagination={paginationOptions}
        dataSource={integrations?.filter(v => !removed.includes(v.uuid))}
        onChange={(pagination: any, filters: any, sorter: any) => this.handleTableChange(pagination, sorter, loadIntegrations)}
      />
    )
  }
}
